import { RocketLaunchIcon, PlayIcon } from '@heroicons/react/24/outline';
import ButtonComponent from '../customButton';
import { CREATE_LAUNCH_DISABLED_TOOLTIP } from './testGroupDetailOverview.constants';
import {
  TEST_GROUP_LAUNCHES_EMPTY_CONTENT,
  LAUNCHES_EMPTY_PREVIEW_FEATURES,
} from './testGroupLaunchesEmpty.constants';
import { LAUNCHES_EMPTY_ICON_MAP } from './testGroupLaunchesEmpty.config';
import styles from '../../styles/testGroupDetail/testGroupLaunchesEmptyPanel.module.scss';

export default function TestGroupLaunchesEmptyPanel({
  onCreateLaunch,
  isCreateLaunchDisabled = false,
}) {
  const content = TEST_GROUP_LAUNCHES_EMPTY_CONTENT;
  const isDisabled = isCreateLaunchDisabled || typeof onCreateLaunch !== 'function';

  return (
    <div className={styles.container}>
      <div className={styles.iconSection}>
        <RocketLaunchIcon className={styles.icon} aria-hidden="true" />
      </div>
      <h3 className={styles.title}>{content.title}</h3>
      <p className={styles.description}>{content.description}</p>
      <ButtonComponent
        ctaText={content.ctaLabel}
        variant="primary"
        className={`white bg-blue600 ${styles.cta}`}
        startIcon={<PlayIcon className="icon" />}
        onClick={onCreateLaunch}
        disabled={isDisabled}
        tooltip={isCreateLaunchDisabled ? CREATE_LAUNCH_DISABLED_TOOLTIP : ''}
        size="small"
      />
      <div className={styles.previewPanel}>
        <p className={styles.previewPanelTitle}>{content.previewPanelTitle}</p>
        <ul className={styles.featureGrid}>
          {LAUNCHES_EMPTY_PREVIEW_FEATURES.map((feature) => {
            const Icon = LAUNCHES_EMPTY_ICON_MAP[feature.iconKey];
            return (
              <li key={feature.id} className={styles.featureItem}>
                <span className={styles.featureIconWrap}>
                  <Icon className={styles.featureIcon} aria-hidden="true" />
                </span>
                <span className={styles.featureText}>
                  <span className={styles.featureTitle}>{feature.title}</span>
                  <span className={styles.featureDescription}>{feature.description}</span>
                </span>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
